/* eslint-disable no-promise-executor-return */
export const sleep = (delay: number) =>
  new Promise((resolve) => setTimeout(() => resolve(true), delay));
